export const ADMIN_SCOPE = 'admin';

export default {
  ADMIN_SCOPE,
};
